module.exports = __webpack_public_path__ + "fonts/brandon.aba7d125.ttf";